import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CustomGoBack from "../customGoBack/CustomGoBack";
import CustomTextBox from "../customTextBox/CustomTextBox";
import CustomButton from "../customButton/CustomButton";
import { resetPwd } from "../../api/forgotPwdApi";
import { LoadPanel, TextBox } from "devextreme-react";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
import {
  setCustomerPassword,
  setPassword,
  setUserPassword,
} from "../../api/registerUserApi";
import "./SetPassword.scss";
export default function SetPassword({
  emailOtp,
  action,
  onChangePwdGoBack,
  onPasswordSaved,
  role,
}) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);


  const newPwdRef = useRef(null);
  const confirmPwdRef = useRef(null);

  const togglePasswordVisibility = () => {
    setShowNewPwd((prevState) => !prevState);
  };

  const handleKeyDown = (e, field) => {
    if (e.key === "Enter") {
      if (field === "new") {
        confirmPwdRef.current.instance.focus();
      } else if (field === "confirm") {
        handleChangePwdContinue();
      }
    }
  };

  const handleChangePwdContinue = async () => {
    if (!newPassword || !confirmPassword) {
      return ToastDisplayer("error", "Both fields are required.");
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

    if (!passwordRegex.test(newPassword)) {
      return ToastDisplayer(
        "error",
        "Password must be 6+ chars with upper, lower, number & special character.",
      );
    }

    if (newPassword !== confirmPassword) {
      return ToastDisplayer("error", "Passwords do not match.");
    }

    try {
      setLoading(true);

      let result;

      if (action === "C") {
        result = await setPassword(emailOtp, newPassword, confirmPassword);
      } else {
        // Forgot password flow
        result = await setPassword(emailOtp, newPassword, confirmPassword);
      }

      if (result?.status === 200) {
        ToastDisplayer("success", result.data.message);
        onPasswordSaved();
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.error || "An unexpected error occurred.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <CustomGoBack onGoBack={onChangePwdGoBack} />

      <div className="resetHeader">Set Password</div>
      <div className="resetText" style={{ marginBottom: 4 }}>
        Type new password to complete account setup
      </div>

      <label className="TextBoxLabel" >
        New Password<span className="requiredClass">*</span>
      </label>
      <div className="TextBoxWrapper">
        <TextBox
          style={{ marginBottom: 10 }}
          placeholder="Set your new password"
          value={newPassword}
          mode={showNewPwd ? "text" : "password"}
          stylingMode="outlined"
          valueChangeEvent="keyup"
          onValueChanged={(e) => setNewPassword(e.value)}
          ref={newPwdRef}
          onKeyDown={(e) => handleKeyDown(e.event, "new")}
        >
          <span className="eye-icon" onClick={() => setShowNewPwd((prevState) => !prevState)}>
            <i
              className={
                showNewPwd ? "ri-eye-off-line" : "ri-eye-line"
              }
            ></i>
          </span>
        </TextBox>
      </div>


      {/* <CustomTextBox
        style={{ marginBottom: 14 }}
        label="New Password"
        placeholder="Set your new password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.value)}
        ref={newPwdRef}
        onKeyDown={(e) => handleKeyDown(e.event, "new")}
        type="password"
      /> */}

      <label className="TextBoxLabel">
        Confirm Password<span className="requiredClass">*</span>
      </label>
      <div className="TextBoxWrapper">
        <TextBox
          style={{ marginBottom: 20 }}
          placeholder="Confirm your password"
          value={confirmPassword}
          mode={showConfirmPwd ? "text" : "password"}
          stylingMode="outlined"
          valueChangeEvent="keyup"
          onValueChanged={(e) => setConfirmPassword(e.value)}
          ref={confirmPwdRef}
          onKeyDown={(e) => handleKeyDown(e.event, "confirm")}
        >
          <span className="eye-icon" onClick={() => setShowConfirmPwd((prevState) => !prevState)}>
            <i
              className={
                showConfirmPwd ? "ri-eye-off-line" : "ri-eye-line"
              }
            ></i>
          </span>
        </TextBox>
        {/* <span className="eye-icon" onClick={togglePasswordVisibility}>
                <i
                  className={
                    passwordVisible ? "ri-eye-off-line" : "ri-eye-line"
                  }
                ></i>
              </span> */}

      </div>


      {/* <CustomTextBox
        label="Confirm Password"
        placeholder="Confirm your password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.value)}
        ref={confirmPwdRef}
        onKeyDown={(e) => handleKeyDown(e.event, "confirm")}
        type="password"
      /> */}

      <div className="mySpace">
        <CustomButton text="Continue" onClick={handleChangePwdContinue} />
      </div>
    </>
  );
}
